import { render, staticRenderFns } from "./productAttribute.vue?vue&type=template&id=1bdeb716&scoped=true&"
import script from "./productAttribute.vue?vue&type=script&lang=js&"
export * from "./productAttribute.vue?vue&type=script&lang=js&"
import style0 from "./productAttribute.vue?vue&type=style&index=0&id=1bdeb716&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdeb716",
  null
  
)

export default component.exports